var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 81,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-13.568%",
    y1: "55.246%",
    x2: "100.758%",
    y2: "34.664%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2522",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03D1E",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46516",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99C0C",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-998.158%",
    y1: "359.279%",
    x2: "673.524%",
    y2: "-132.084%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1005.479%",
    y1: "358.738%",
    x2: "615.878%",
    y2: "-115.534%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1066.046%",
    y1: "365.777%",
    x2: "616.457%",
    y2: "-110.305%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1014.734%",
    y1: "404.689%",
    x2: "595.73%",
    y2: "-131.875%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1657.981%",
    y1: "565.641%",
    x2: "586.731%",
    y2: "-112.291%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1079.69%",
    y1: "412.944%",
    x2: "597.226%",
    y2: "-125.648%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1558.74%",
    y1: "547.146%",
    x2: "583.656%",
    y2: "-114.907%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-947.837%",
    y1: "352.658%",
    x2: "616.299%",
    y2: "-121.969%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2150.496%",
    y1: "738.994%",
    x2: "586.236%",
    y2: "-118.114%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.428%",
    y1: "73.389%",
    x2: "189.778%",
    y2: "3.349%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3177.391%",
    y1: "1224.283%",
    x2: "576.422%",
    y2: "-140.922%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1712.648%",
    y1: "559.104%",
    x2: "577.213%",
    y2: "-102.271%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2014.589%",
    y1: "729.379%",
    x2: "579.927%",
    y2: "-124.324%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3673.216%",
    y1: "1581.389%",
    x2: "572.663%",
    y2: "-165.162%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3524.552%",
    y1: "1469.862%",
    x2: "576.301%",
    y2: "-159.389%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1919.752%",
    y1: "723.008%",
    x2: "585.616%",
    y2: "-132.755%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-859.272%",
    y1: "370.16%",
    x2: "616.7%",
    y2: "-161.76%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1221.988%",
    y1: "515.397%",
    x2: "584.492%",
    y2: "-145.462%",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1310.87%",
    y1: "529.701%",
    x2: "586.631%",
    y2: "-138.487%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2437.852%",
    y1: "800.223%",
    x2: "600.613%",
    y2: "-115.46%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1392.546%",
    y1: "525.054%",
    x2: "585.132%",
    y2: "-126.599%",
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2496.889%",
    y1: "810.226%",
    x2: "586.058%",
    y2: "-110.259%",
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2254.896%",
    y1: "741.967%",
    x2: "583.638%",
    y2: "-110.295%",
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-800.615%",
    y1: "286.045%",
    x2: "853.538%",
    y2: "-185.378%",
    id: "y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3360.989%",
    y1: "1351.59%",
    x2: "579.171%",
    y2: "-151.962%",
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-83.065%",
    y1: "81.38%",
    x2: "191.099%",
    y2: "19.212%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1122.153%",
    y1: "374.684%",
    x2: "614.924%",
    y2: "-107.564%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1492.063%",
    y1: "364.487%",
    x2: "630.688%",
    y2: "-71.911%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-611.848%",
    y1: "305.393%",
    x2: "619.124%",
    y2: "-169.093%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1354.315%",
    y1: "457.57%",
    x2: "597.28%",
    y2: "-108.919%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1474.208%",
    y1: "555.141%",
    x2: "584.357%",
    y2: "-126.065%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1211.942%",
    y1: "427.912%",
    x2: "595.081%",
    y2: "-112.878%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1149.435%",
    y1: "423.477%",
    x2: "597.473%",
    y2: "-120.162%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-981.627%",
    y1: "461.168%",
    x2: "744.65%",
    y2: "-218.507%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1281.032%",
    y1: "450.623%",
    x2: "595.195%",
    y2: "-114.592%",
    id: "J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-719.84%",
    y1: "320.216%",
    x2: "614.661%",
    y2: "-147.882%",
    id: "K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-954.092%",
    y1: "401.315%",
    x2: "601.902%",
    y2: "-142.836%",
    id: "L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-892.196%",
    y1: "397.549%",
    x2: "601.547%",
    y2: "-153.067%",
    id: "M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1782.273%",
    y1: "557.105%",
    x2: "574.537%",
    y2: "-94.669%",
    id: "N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-669.125%",
    y1: "315.154%",
    x2: "619.922%",
    y2: "-159.843%",
    id: "O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341F6B",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651E58",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11D3B",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2E20",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45F17",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB08",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087AE",
    d: "M362.04 0H414v69.86h-51.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M388.1 15.95l6.19 6.19 8.88-.03L388.1 7.04l-19.54 19.53 4.46 4.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEDC00",
    d: "M403.18 22.11L388.1 37.19l-6.12-6.12-8.92-.01L388.1 46.1l19.53-19.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63 59.57c-1.51-.39-1.8-.45-1.8-.91s.49-.68.91-.68c.63 0 1.15.19 1.19.91h1.28c0-1.39-1.16-1.94-2.41-1.94a2 2 0 00-2.25 1.82c0 1.13.9 1.48 1.8 1.71.9.23 1.79.35 1.79 1s-.71.75-1.17.75c-.71 0-1.33-.31-1.33-1.11h-1.28c0 1.49 1.23 2.14 2.57 2.14 1.64 0 2.51-.83 2.51-1.93-.02-1.37-1.37-1.66-1.81-1.76zM375.61 61.04c0 .89-.28 1.25-.93 1.25s-.77-.35-.77-1.07v-2.46h-1.2v2.68c0 1.08.32 1.8 1.59 1.8a1.56 1.56 0 001.33-.73v.61h1.14v-4.36h-1.2l.04 2.28zM379.74 58.67a1.45 1.45 0 00-1.3.68v-.56h-1.14v5.88h1.2v-2.09c.298.426.79.674 1.31.66a2 2 0 001.92-2.25c-.01-1.25-.62-2.32-1.99-2.32zm-.25 3.7c-.78 0-1-.68-1-1.38 0-.7.25-1.41 1-1.41s1 .72 1 1.41-.22 1.34-1 1.34v.04zM384.16 58.67a2.19 2.19 0 00-2.23 2.3 2.13 2.13 0 002.23 2.3 2 2 0 002-1.47h-1.05a1 1 0 01-.95.57c-.67 0-1-.35-1.07-1.11h3.15a2.2 2.2 0 00-2.08-2.59zm-1 1.83a.94.94 0 011-.93c.58 0 .84.32 1 .93h-2zM387.72 59.57v-.81h-1.14v4.36h1.2v-2c0-.77.3-1.4 1.18-1.4.179.012.356.038.53.08v-1.13a1.69 1.69 0 00-.36-.06 1.54 1.54 0 00-1.41.96zM391.09 58.15h2.72v-1.13h-4.06v6.12h1.34v-2.53h2.73v-1.04h-2.73zM397.24 61.04c0 .9-.28 1.27-.94 1.27-.66 0-.78-.36-.78-1.09v-2.55h-1.22v2.72c0 1.1.33 1.82 1.62 1.82a1.58 1.58 0 001.35-.74v.62h1.16v-4.42h-1.22l.03 2.37zM401.49 58.6a1.58 1.58 0 00-1.35.74v-.67H399v4.43h1.22v-2.28c0-.9.28-1.27.94-1.27.66 0 .78.36.78 1.09v2.5h1.22v-2.72c-.05-1.1-.38-1.82-1.67-1.82zM406.7 59.26a1.55 1.55 0 00-1.32-.66 2.05 2.05 0 00-2 2.3c0 1.22.65 2.37 2 2.37a1.47 1.47 0 001.34-.69v.57h1.16v-6.12h-1.18v2.23zm-1 3.09c-.75 0-1.07-.73-1.07-1.42s.27-1.41 1.07-1.41 1 .69 1 1.4-.19 1.43-1 1.43zM379.34 48.96h1.32v6.02h-1.32zM382.33 52.67c0-.89.28-1.25.93-1.25s.77.35.77 1.07v2.46h1.2v-2.64c0-1.08-.32-1.8-1.59-1.8a1.56 1.56 0 00-1.33.73v-.57h-1.14v4.36h1.2l-.04-2.36zM388.82 54.44V55H390v-6h-1.2v2.19a1.53 1.53 0 00-1.3-.65 2 2 0 00-1.93 2.26c0 1.21.64 2.34 2 2.34a1.45 1.45 0 001.25-.7zm-2.08-1.63c0-.72.27-1.39 1.05-1.39s1 .68 1 1.38c0 .7-.24 1.41-1 1.41s-1.06-.72-1.06-1.4h.01zM391.92 55.11a1.56 1.56 0 001.33-.73v.61h1.14v-4.32h-1.2v2.29c0 .89-.28 1.25-.93 1.25s-.77-.35-.77-1.07v-2.47h-1.2v2.68c.04 1.04.36 1.76 1.63 1.76zM397.31 52.37c-.68-.16-1.36-.22-1.36-.65 0-.43.4-.4.67-.4.43 0 .78.13.82.59h1.14c-.09-1.07-1-1.39-1.92-1.39-.92 0-1.9.29-1.9 1.4 0 .77.69 1 1.38 1.16.86.19 1.36.31 1.36.68 0 .37-.44.56-.78.56s-.91-.21-.92-.73h-1.14c.05 1.16 1 1.54 2.05 1.54 1.05 0 2-.37 2-1.52-.01-.83-.71-1.08-1.4-1.24zM399.38 54.01c0 .87.64 1 1.38 1 .233.018.467.018.7 0v-.94a1.84 1.84 0 01-.37 0c-.41 0-.51-.1-.51-.51v-2.13h.88v-.76h-.88v-1.35h-1.2v1.35h-.73v.8h.73v2.54zM404.45 51.67l1.13 3.07a.66.66 0 01-.64.85h-.06v1.08h.12a1.72 1.72 0 001.71-1l1.82-5h-1.24l-1 3-1-3h-1.31a1.33 1.33 0 00-1.15.88v-.88h-1.14v4.36h1.2v-2c0-.77.3-1.4 1.18-1.4l.38.04zM369.35 53.67h2.26l.46 1.34h1.38l-2.26-6h-1.36l-2.29 6h1.34l.47-1.34zm1.13-3.21l.76 2.22h-1.54l.78-2.22zM374.67 52.67c0-.89.28-1.25.93-1.25s.77.36.77 1.07v2.47h1.2v-2.64c0-1.08-.32-1.8-1.6-1.8a1.56 1.56 0 00-1.34.73v-.58h-1.14v4.37h1.2l-.02-2.37z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.42.51c-3.55.41-4.4 2.28-2.6 2.84l16.77 5.06c2.33.75 6.16 1.85 6.29 3.69.15 2-3.34 4.18-5.37 5.58l-23.6 15.29c-5.07 3.51-2.11 5.11.35 4.72A75.16 75.16 0 00301 34.1a161 161 0 0017.38-7.71c5.5-2.87 10.45-6 13.69-9.08 3.07-2.91 4.58-5.75 3.65-8.3-.93-2.55-3.47-4.18-6.86-5.48a51.25 51.25 0 00-11.4-2.56 105.49 105.49 0 00-11.53-.79 63.87 63.87 0 00-8.51.33z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68 48.8l-1.66-.5c-3.31-1-7.94-2.27-7.94-5.78 0-3.51 2.86-5.36 6.37-5.36 4.2 0 5.79 2 6.08 5.43v.27h6.37v-.3c-.06-8.8-7.66-10.11-12.19-10.11-6.35 0-13.14 2.79-13.14 10.61 0 7 6.77 9.16 12.2 10.89l1.42.46c3 1 6 2.21 6 5.28 0 3.81-3.2 5.81-7.13 5.81-4.49 0-6.65-2.46-6.94-6.08v-.28h-6.38v.31c.34 7 5.14 10.95 13.19 10.95 6.39 0 13.85-2.95 13.85-11.26 0-6.39-4.99-8.61-10.1-10.34zm94.48 8.31c0-8.75-2.65-16-12.17-16-8.89 0-13.28 6.35-13.28 15.15 0 8.57 4.44 14.2 13 14.2 6.14 0 11.38-2.9 12.38-9.86h-5.93c-.48 3.68-2.8 5.79-6.24 5.79-4.87 0-7.14-4.17-7.14-8.85v-.44l19.38.01zm-12.28-11.86c4.39 0 6.3 3.73 6.3 7.91H295.9c.37-4.24 2.59-7.91 6.98-7.91zm29.67-3.68a8.61 8.61 0 00-8.15 4.85l-.1-4.62h-5.88v28.06h6.13V55.55c0-5.18 1.85-8.3 7.09-8.3a18.53 18.53 0 012.32.22v-5.8c-.5 0-.96-.1-1.41-.1zM122 41.3c-4.77 0-9.87 2.07-9.93 7.86v.31h3.85v-.27c.37-3.35 2.19-4.78 6.06-4.78 4.47 0 6.38 2 6.38 6.76v1.59h-.72c-6 0-17.27 0-17.27 9.33 0 6.17 5.32 8.36 9.88 8.36 4.2 0 6.46-1.21 8.58-4.07v3.47h3.41V51.23c-.03-6.87-3.24-9.93-10.24-9.93zm-1.18 26.15c-3.13 0-6.49-1.71-6.49-5.46 0-5.56 6.46-6.27 12.09-6.27.82 0 1.2 0 2 .09-.06 6.18-.37 11.64-7.65 11.64h.05zM19 33.08h-4L0 69.86h4.54l3.86-10h17.38l4.05 10h4.89L19.11 33.08H19zM9.83 56.17l7-18.06 7.4 18.06H9.83zm78.34 6.26V44.86h6.14v-3.07h-6.14v-7.83h-3.93V63.9c0 4.16 2 6.18 6.13 6.18a29.45 29.45 0 003.9-.27h.27v-3.46a15 15 0 01-2.81.35c-3.22-.03-3.56-1.3-3.56-4.26v-.01zm48.55-29.35v36.78h3.93V33.09h-3.93v-.01zm8.47 8.71v28.07h3.93V41.79H145.19zm19-.49c-4.76 0-9.87 2.07-9.93 7.86v.31h3.85v-.27c.37-3.35 2.18-4.78 6.05-4.78 4.48 0 6.39 2 6.39 6.76v1.59h-.73c-6 0-17.28 0-17.28 9.33 0 6.17 5.32 8.36 9.88 8.36 4.21 0 6.47-1.21 8.59-4.07v3.47h3.42V51.23c.01-6.87-3.16-9.93-10.26-9.93h.02zM163 67.45c-3.12 0-6.48-1.71-6.48-5.46 0-5.56 6.46-6.27 12.09-6.27.82 0 1.2 0 2 .09-.02 6.18-.33 11.64-7.61 11.64zM71.73 53.72c-3.76-1-7-1.91-7-5 0-3.41 4-4.31 6.05-4.31 3.71 0 5.53 1.62 5.73 5.09v.29h3.92v-.31c-.15-5.38-3.62-8.35-9.77-8.35-4.92 0-9.88 2.45-9.88 7.92s4.93 6.79 9.28 8c3.83 1.05 7.14 2 7.14 5.17 0 3.73-4 5.08-6.71 5.08-4.12 0-6.49-2.11-6.49-5.78v-.31h-3.85v.31c0 5.65 3.72 8.9 10.2 8.9 4.93 0 10.69-2.27 10.69-8.68-.04-5.48-4.95-6.83-9.31-8.02zm75.38-20.83a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-94 23.56c0 3.09-.75 10.29-7.71 10.29-4.56 0-6.51-2.74-6.51-9.15v-15.8H35V58.9c0 7.77 3 11.24 9.86 11.24a9.7 9.7 0 008.43-4.11v3.84h3.77V41.79h-3.94l-.01 14.66zM191 41.52a9.68 9.68 0 00-8.44 4.27v-4h-3.85v28.07h3.93V54.93c0-3.75 1-10 7.76-10 5.86 0 6.34 4.14 6.34 9.15v15.8h3.93V52.76c-.09-7.77-3.06-11.24-9.67-11.24zm-79.9.15c-.42 0-.84-.08-1.23-.08a9.42 9.42 0 00-8.17 3.87c-.05-1.12 0-3.71 0-3.71h-3.89v28.11h3.93V54.01c0-5.92 2.29-8.55 7.41-8.55.65.013 1.299.073 1.94.18l.01-3.97zM251.61 56.5c0 4.62-1.29 9.19-6.31 9.19s-5.44-4.18-5.44-8.63V41.8h-6.14v17.76c0 6.68 3 10.69 9.54 10.69 3.79 0 6.22-1.5 8.45-4.62l.1 4.23h5.93V41.8h-6.13v14.7zm24.62-15.32a9.41 9.41 0 00-8.62 5.07l-.1-4.45h-5.88v38.64h6.13V66.08c2.11 3 4.41 4.34 8 4.34 7.9 0 11.54-7.4 11.54-15 .02-7.5-3.36-14.24-11.06-14.24h-.01zm-2 25c-5.13 0-6.52-5.62-6.52-10.25 0-4.9 1.7-10.47 7-10.47 5.08 0 6.57 5.63 6.57 10.25-.06 4.96-1.71 10.48-7.09 10.48l.04-.01z",
    fill: "#1E155D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.46 9.58c-.06-.57-.92-.95-1.88-.82a2.42 2.42 0 00-1.33.54c.892.31 1.742.73 2.53 1.25.46-.26.73-.61.68-.97z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31 6.25c.93-.11 1.63-.62 1.56-1.12-.07-.5-.83-.81-1.73-.7-.9.11-1.61.59-1.58 1.09.03.5.82.84 1.75.73z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1 4.18c.89-.1 1.58-.58 1.51-1.05-.07-.47-.81-.75-1.67-.64-.86.11-1.55.55-1.52 1 .03.45.79.81 1.68.69z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.81 15.45c.9-.12 1.58-.67 1.47-1.27-.11-.6-.93-.94-1.83-.83-.9.11-1.57.65-1.49 1.23.08.58.9.97 1.85.87z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.17 5.85c-.67.08-1.12.45-1 .82.12.37.67.62 1.35.54.68-.08 1.14-.45 1-.84-.14-.39-.71-.59-1.35-.52z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.31 12.76c.89-.1 1.52-.64 1.41-1.17-.11-.53-.88-.88-1.75-.77-.87.11-1.49.62-1.44 1.15.05.53.89.89 1.78.79z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68 8.08c-.69.08-1.17.47-1.07.87.1.4.71.67 1.41.59.7-.08 1.18-.48 1.07-.89-.11-.41-.73-.65-1.41-.57z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35 6.52c-.95.11-1.67.63-1.62 1.17.05.54.86.9 1.81.79.95-.11 1.69-.66 1.62-1.2-.07-.54-.89-.88-1.81-.76z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.33 10.2c-.52.07-.88.36-.79.69.09.33.61.53 1.15.47.54-.06.89-.38.78-.7-.11-.32-.61-.52-1.14-.46z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.92 28.11a2.26 2.26 0 00-2.51-1.38c1.34-.21 2.34-1.15 2.27-2.15-.07-1-1.12-1.59-2.42-1.49 1.29-.19 2.23-1.07 2.17-2-.06-.93-1-1.42-2.16-1.37 1.15-.23 2-1 1.92-1.79a1.21 1.21 0 00-.68-1l-1 .68-2.51 1.67a2.43 2.43 0 001.74.52 2.92 2.92 0 00-1.74 1 1.76 1.76 0 00-1-.82l-20.08 13c-5.24 3.45-2.11 5.11.35 4.72A75.22 75.22 0 00301 34.1c4.28-1.62 9.18-3.68 13.92-5.99zm-5.07-5.86a2.22 2.22 0 002.17.87 3 3 0 00-1.94 1.1 2 2 0 00-1.4-1 3 3 0 001.17-.97zm0 3.57a2.31 2.31 0 002.28.94 3.09 3.09 0 00-2.06 1.21 2.09 2.09 0 00-1.46-1.09 3.1 3.1 0 001.29-1.06h-.05zm-4.65-2.85c.28.262.626.444 1 .53a3.3 3.3 0 00-1.09.8 2.1 2.1 0 00-.79-.57 3.33 3.33 0 00.93-.76h-.05zm-.16 3.62a2.22 2.22 0 001.08.59 3.48 3.48 0 00-1.14.87 2.2 2.2 0 00-.83-.64 3.59 3.59 0 00.93-.82h-.04zm-.19 4c.301.324.69.553 1.12.66a3.69 3.69 0 00-1.2.95 2.29 2.29 0 00-.87-.69 3.79 3.79 0 00.99-.96l-.04.04zm-5.36 1.77a2.4 2.4 0 00-.34-.29 4.61 4.61 0 00.42-.39c.132.109.277.203.43.28a4.39 4.39 0 00-.47.37l-.04.03zm.46-4.09a2.25 2.25 0 00-.34-.27 4.43 4.43 0 00.4-.35c.133.103.277.19.43.26-.154.1-.3.21-.44.33l-.05.03z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.72 12.98a.82.82 0 00.87.35c.37 0 .6-.28.54-.52a.86.86 0 00-.87-.36c-.37.07-.61.3-.54.53z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.69 3.78c-.64.07-1.09.42-1 .76.09.34.67.58 1.32.5.65-.08 1.11-.43 1-.78-.11-.35-.69-.59-1.32-.48z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11 12.77c-.54.06-.9.4-.83.74.24.415.724.623 1.19.51.57-.07 1-.4.84-.75a1.11 1.11 0 00-1.2-.5z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.93 5.99c.36 0 .58-.23.5-.42-.08-.19-.41-.31-.74-.26-.33.05-.56.22-.5.41.06.19.4.31.74.27z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.77 8.26c.34 0 .57-.25.49-.45-.08-.2-.43-.34-.77-.29-.34.05-.59.25-.51.45.08.2.42.33.79.29z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33 16.93c.6-.08 1-.44.85-.82a1.15 1.15 0 00-1.24-.55c-.57.08-1 .43-.84.8.16.37.67.64 1.23.57z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 22.42c-1 .12-1.77.82-1.65 1.56.07.414.345.763.73.93 1-.553 1.967-1.117 2.9-1.69a2 2 0 00-1.98-.8z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.65 20.9c.83-.11 1.38-.65 1.24-1.2a1.52 1.52 0 00-1.7-.82c-.81.1-1.35.61-1.24 1.17a1.52 1.52 0 001.7.85z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.92 17.67c.79-.09 1.31-.59 1.17-1.11-.14-.52-.83-.83-1.61-.75-.78.08-1.28.57-1.19 1.08.283.62.97.948 1.63.78z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.21 6.19c.09.28.54.46 1 .4.46-.06.83-.33.75-.61a1 1 0 00-.96-.39c-.5.08-.86.33-.79.6z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.23 14.76c.75-.09 1.26-.56 1.15-1-.11-.44-.8-.78-1.55-.69-.75.09-1.24.54-1.14 1 .1.46.8.78 1.54.69z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34 3.53c-.47.05-.79.3-.72.56.07.26.54.43 1 .37.46-.06.81-.31.72-.57-.09-.26-.51-.43-1-.36z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 7.81c-.49.06-.83.36-.75.64.08.28.56.49 1.09.43s.86-.35.78-.65c-.08-.3-.6-.48-1.12-.42z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59 26.26a2.88 2.88 0 00-1.19-.11 2.19 2.19 0 00-2.06 1.76c1-.5 2-1 3-1.51l.25-.14z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14 10.21c-.07-.21-.45-.36-.79-.31-.34.05-.62.26-.55.48a.8.8 0 00.82.33c.38-.04.59-.28.52-.5z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.93.18a64 64 0 00-8.51.32c-3.55.41-4.4 2.28-2.6 2.84l16.77 5.06.92.29c.6-.27 1-.69 1-1.13 0-.44-.72-.89-1.51-.89.83-.22 1.42-.71 1.37-1.21-.05-.5-.72-.79-1.57-.79.84-.2 1.42-.71 1.37-1.19-.05-.48-.64-.81-1.43-.81.77-.2 1.34-.68 1.3-1.12-.04-.44-.61-.71-1.37-.71a2.65 2.65 0 00.91-.39c-2.32-.14-4.58-.24-6.65-.27zm-3.41 3.74l-.24-.13.28-.19c.1.05.203.09.31.12a3 3 0 00-.34.21l-.01-.01zm.21-1.88l-.23-.12.24-.17.31.1-.32.19zM306 5.67a1.57 1.57 0 00-.61-.32c.24-.117.46-.273.65-.46.24.159.514.258.8.29a2.67 2.67 0 00-.84.49zm.09-2a1.56 1.56 0 00-.59-.29 2.41 2.41 0 00.63-.43c.227.145.483.238.75.27a2.64 2.64 0 00-.81.45h.02zm.1-1.87a1.54 1.54 0 00-.59-.28 2.36 2.36 0 00.7-.49 2 2 0 00.88.26 2.7 2.7 0 00-1.02.55l.03-.04zm3.45-1.25a1.74 1.74 0 001.25.41 2 2 0 00-1.25.73 1.49 1.49 0 00-1.12-.5c.424-.11.81-.33 1.12-.64zM311 2.8a2.1 2.1 0 00-1.29.76 1.45 1.45 0 00-1-.51 1.92 1.92 0 001-.74c.339.343.81.522 1.29.49zm-1.27 1.42a1.7 1.7 0 001.38.52 2.15 2.15 0 00-1.37.83 1.46 1.46 0 00-1.05-.56 2 2 0 00.99-.79h.05zm0 3.41a1.25 1.25 0 00-.84-.63 1.77 1.77 0 00.82-.74 1.7 1.7 0 001.36.52 2.15 2.15 0 00-1.35.89l.01-.04z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27 1.67c0 .45.76.73 1.63.63.87-.1 1.52-.55 1.46-1 0-.2-.19-.36-.44-.47l-1.23-.16c-.81.09-1.45.52-1.42 1z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 .92a.4.4 0 00-.06.26c.05.38.73.63 1.45.54a1.77 1.77 0 001.08-.46l-2.06-.29-.41-.05z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45 25.75c1.24-.14 2.13-1 2-1.89-.13-.89-1.17-1.44-2.35-1.3-1.18.14-2.07 1-2 1.82.07.82 1.13 1.52 2.35 1.37z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53 2.16c-.76.08-1.32.48-1.27.89.05.41.74.62 1.51.62s1.33-.54 1.23-1c-.1-.46-.73-.6-1.47-.51z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.59 12.05c.75-.08 1.24-.52 1.11-1-.13-.48-.76-.71-1.47-.63-.71.08-1.2.51-1.11.94.09.43.76.78 1.47.69z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.2 6.18c-.79.1-1.41.55-1.35 1 .06.45.79.77 1.63.68.84-.09 1.43-.56 1.33-1-.1-.44-.81-.77-1.61-.68z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.57 8.41c-.83.11-1.46.57-1.38 1.07.08.5.82.84 1.68.73.86-.11 1.48-.59 1.38-1.09-.1-.5-.85-.81-1.68-.71z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4 16.03c1.06-.13 1.87-.79 1.8-1.47a1.2 1.2 0 00-.86-.86 10.52 10.52 0 01-2.25 2.17 2.55 2.55 0 001.31.16z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.85 4.1c-.78.09-1.36.51-1.3 1 .06.49.76.71 1.56.62.8-.09 1.39-.54 1.29-1-.1-.46-.79-.71-1.55-.62z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72 18.99c1.14-.13 2-.86 1.85-1.6-.15-.74-1-1.21-2.13-1.07-1.13.14-1.92.82-1.88 1.54.04.72 1.03 1.26 2.16 1.13z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.26 18.42c1-.11 1.64-.72 1.5-1.37-.14-.65-1-1-1.88-.92-.88.08-1.63.7-1.55 1.33.08.63.96 1.08 1.93.96z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.87 21.67c1-.13 1.72-.79 1.62-1.48a1.78 1.78 0 00-2-1c-1 .12-1.68.77-1.58 1.45.1.68.95 1.18 1.96 1.03z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22 1.84c-.62.08-1.06.4-1 .72.06.32.64.54 1.27.46.63-.08 1.06-.4 1-.74-.06-.34-.65-.51-1.27-.44z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.07 22.24c1.15-.14 2-.92 1.91-1.73-.09-.81-1.09-1.31-2.23-1.18-1.14.13-2 .88-1.93 1.68.07.8 1.07 1.37 2.25 1.23z",
    fill: "url(#O)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.61b559dbcfdeabf517985ef056fa38b4.svg";